export default __webpack_public_path__ + "static/media/ic_edit_pen.cb26049a.svg";